export const en = {
    translation: {
        app: {
            header: {
                switchTenant: 'Switch tenant',
            },
            navigationBar: {
                settings: 'Tenant settings',
                switch: 'Switch tenant',
                aiAssistant: 'AI Assistant',
            },
            user: {
                myProfile: 'My account settings',
                logout: 'Logout',
            },
            applications: {
                root: {
                    name: 'Manage tenant',
                    description: 'Your tenants start page and settings',
                },
            },
        },
        components: {
            noAccountingPlanAccess: 'You have no access to accounting plan',
            noCostCentersAccess: 'You have no access to cost centers',
            advancedFormEditor: {
                textFormatPrompt: 'Set the type of the input',
                survey: {
                    ed: {
                        designer: 'Form',
                    },
                },
                dialog: {
                    saveFail: {
                        title: 'Unable to save form',
                        message: 'Something went wrong to save the form please try again',
                    },
                },
            },
            importer: {
                importAction_zero: 'Nothing to import',
                importAction_one: 'Import {{count, number}} row now',
                importAction_other: 'Import {{count, number}} rows now',
                parseData: {
                    parseError: 'The file could not be correctly parsed',
                    emptyError: {
                        title: 'No data',
                        message: 'The file contained no data',
                    },
                    tooManyRows: {
                        title: 'Too many rows',
                        message: 'The file contains more than the allowed {{maxRows, number}} rows',
                    },
                },
                upload: {
                    uploadTitle: 'Parsing file',
                    format: 'CSV',
                },
                map: {
                    column: 'Column #{{column}}',
                    errors: {
                        required: 'A value is required',
                        invalidDate: 'Invalid date "{{date}}"',
                        invalidNumber: 'Invalid number "{{number}}"',
                        invalidBoolean: 'Invalid boolean "{{boolean}}"',
                    },
                    toolbar: {
                        totalRows_one: '{{count, number}} row',
                        totalRows_other: '{{count, number}} rows',
                        importableRows: '{{count, number}} importable',
                        errorRows: '{{count, number}} with error',
                        hasHeaderRow: 'Header row',
                        hiddenColumns_zero: 'Show all columns',
                        hiddenColumns_one: 'One hidden column',
                        hiddenColumns_other: '{{count, number}} hidden columns',
                        requiredColumns_one: 'One required column',
                        requiredColumns_other: '{{count, number}} required columns',
                        requiredColumnsMessage: 'The following columns are required to be mapped:',
                        showErrorRowsOnly: 'Show only error rows',
                        showErrorColumnsOnly: 'Show only error columns',
                    },
                    table: {
                        noMapping: 'Keine Zuweisung',
                        mapPlaceholder: 'Zuweisen',
                        errorsCount_none: 'No rows with errors',
                        errorsCount_one: 'One row with errors',
                        errorsCount_other: '{{count,number}} rows with errors',
                        editPrompt: {
                            title: 'Edit value',
                            prompt: 'Enter a new value',
                        },
                    },
                },
                importing: {
                    process: {
                        title_one: 'Importing one row...',
                        title_other: 'Importing {{count, number}} rows...',
                        hint: 'Importing your data now, please do not close your browser window and wait until finished',
                    },
                    results: {
                        title: 'Finished importing',
                        inserted_zero: 'Nothing inserted',
                        inserted_one: 'One newly inserted',
                        inserted_other: '{{count, number}} newly inserted',
                        duplicates_zero: 'No duplicates',
                        duplicates_one: 'One duplicate ignored',
                        duplicates_other: '{{count, number}} duplicates ignored',
                        removed_zero: 'None removed',
                        removed_other: '{{count, number}} removed',
                        updated_zero: 'None updated',
                        updated_other: '{{count, number}} updated',
                        failed_zero: 'None failed',
                        failed_other: '{{count, number}} failed',
                    },
                },
            },
            tagsFilterDropdown: {
                allTags: 'All',
                searchPlaceholder: 'Search for tag',
                noTagsChosen: 'No tags chosen',
            },
            pagination: {
                previousPage: 'Previous page',
                nextPage: 'Next page',
                show: 'Showing {{fromCount, int}} to {{toCount, int}}',
                total: 'of {{count, int}} total',
            },
            page: {
                toolbar: {
                    responsiveTitle: 'Actions and settings',
                },
            },
            rruleEditor: {
                repeats: 'Repeats',
                options: {
                    daily: 'Every Day',
                    weekly: 'Every Week',
                    monthly: 'Every Month',
                    yearly: 'Every Year',
                    custom: 'Custom',
                },
                every: 'Every',
                frequency: 'Frequency',
                frequencies: {
                    daily: 'Day(s)',
                    weekly: 'Week(s)',
                    monthly: 'Month(s)',
                    yearly: 'Year(s)',
                },
                onEach: 'On each',
                onDay: 'On',
                onThe: 'On the',
                advanced: {
                    positions: {
                        first: 'First',
                        second: 'Second',
                        third: 'Third',
                        fourth: 'Fourth',
                        last: 'Last',
                    },
                    options: {
                        day: 'day',
                        week: 'weekday',
                        weekend: 'weekend day',
                    },
                },
                until: {
                    label: 'Ends',
                    after: 'After',
                    times: 'times',
                    onDate: 'On date',
                    none: 'Never',
                },
            },
            conditionGroupEditor: {
                editConditionGroup: 'Edit conditions',
                addCondition: 'Add new condition',
                addGroup: 'Add group',
                matchAll: 'All must match',
                matchAny: 'At least one must match',
                comparatorFunction: {
                    eq: 'Equals',
                    isSet: 'Has a value',
                    lt: 'Is less than',
                    lte: 'Is less or equal',
                    gt: 'Is greater than',
                    gte: 'Is greater or equal',
                    includes: 'Includes one of',
                    contains: 'Contains',
                    startsWith: 'Starts with',
                    endsWith: 'Ends with',
                    before: 'Is before',
                    beforeAt: 'Is before or at',
                    after: 'Is after',
                    afterAt: 'Is after or at',
                    isToday: 'Is today',
                    // -- negation
                    not: {
                        eq: 'Not equals',
                        isSet: 'Has no value',
                        lt: 'Is not less than',
                        lte: 'Is not less or equal',
                        gt: 'Is not greater than',
                        gte: 'Is not greater or equal',
                        includes: 'Does not include one of',
                        contains: 'Does not contain',
                        startsWith: 'Does not starts with',
                        endsWith: 'Does not end with',
                        before: 'Is not before',
                        beforeAt: 'Is not before or at',
                        after: 'Is not after',
                        afterAt: 'Is not after or at',
                        isToday: 'Is not today',
                    },
                },
            },
            expressionEditor: {
                callableFunction: {
                    lowercase: {
                        name: 'Lowercase',
                        info: 'Lowercases a text',
                        params: [{ name: 'Text' }],
                    },
                    uppercase: {
                        name: 'Uppercase',
                        info: 'Uppercases a text',
                        params: [{ name: 'Text' }],
                    },
                    substring: {
                        name: 'Extract text',
                        info: 'Returns a part of a text using a given a range',
                        params: [{ name: 'Text' }, { name: 'Start' }, { name: 'Length' }],
                    },
                    trim: {
                        name: 'Trim text',
                        info: 'Removes any spaces on the left and right side of a text',
                        params: [{ name: 'Text' }],
                    },
                    min: {
                        name: 'Smaller one',
                        info: 'Returns the smaller one of two given numbers',
                        params: [{ name: 'First number' }, { name: 'Second number' }],
                    },
                    max: {
                        name: 'Greater one',
                        info: 'Returns the greater one of two given numbers',
                        params: [{ name: 'First number' }, { name: 'Second number' }],
                    },
                    date: {
                        name: 'Current date',
                        info: 'Returns the current date with no time',
                    },
                    time: {
                        name: 'Current time',
                        info: 'Returns the current date including current time',
                    },
                    age: {
                        name: 'Age',
                        info: 'Given a birthdate calculates the actual age',
                        params: [{ name: 'Birthdate' }],
                    },
                    formatDate: {
                        name: 'Format date/time',
                        info: 'Formats a given date or time',
                        params: [
                            { name: 'Date' },
                            {
                                name: 'Format',
                                options: [
                                    { value: 'date', name: 'Date only' },
                                    { value: 'time', name: 'Time only' },
                                    { value: 'dateTime', name: 'Date and time' },
                                    { value: 'day', name: 'Day of month' },
                                    { value: 'weekdayNumber', name: 'Weekday as number' },
                                    { value: 'weekdayShort', name: 'Weekdayname short' },
                                    { value: 'weekdayLong', name: 'Weekdayname full' },
                                    { value: 'monthNumber', name: 'Month as number' },
                                    { value: 'monthShort', name: 'Monthname short' },
                                    { value: 'monthLong', name: 'Monthname full' },
                                    { value: 'quarterNumber', name: 'Quarter as number' },
                                    { value: 'quarterShort', name: 'Quartername short' },
                                    { value: 'quarterLong', name: 'Quartername full' },
                                    { value: 'year', name: 'Full year' },
                                ],
                            },
                        ],
                    },
                },
                chooseExpression: 'Click to select',
                invalidVariable: 'Invalid variable',
                literal: 'Literal value',
                variable: 'Variable',
                function: 'Function',
                stringLiteral: 'Text',
                literalTrue: 'is set',
                literalFalse: 'is not set',
            },
            priceEditor: {
                gross: 'Gross',
                net: 'Net',
                price: 'Price',
                priceNet: 'Price net',
                priceNetInfo: 'The price excluding sales taxes',
                priceGross: 'Price gross',
                priceGrossInfo: 'The price including sales taxes',
                taxCode: 'Tax',
                account: 'Account',
                costCenter1: 'Cost center 1',
                costCenter2: 'Cost center 2',
            },
        },
    },
}
